import { useField } from 'formik'
import SelectInput from '../SelectInput'
import { withHistoricalOption } from './selectHistoricalOption'

// Lista restrita às opções que o Rodopar aceita para o lote — não usar em outros
// módulos (contratos e cotações continuam usando a lista completa em
// TipoPedagioSelectInput).
export const tiposPedagioLote = [
  { value: 'FIXO', label: 'Fixo' },
  { value: 'POR_EIXO', label: 'R$ por eixo' },
  { value: 'POR_TONELADA', label: 'R$ por tonelada' },
  { value: 'INFORMADO_EMISSAO', label: 'Informado na Emissão' }
]

const LABELS_HISTORICOS: Record<string, string> = {
  POR_QUILOMETRO: 'R$ por quilômetro rodado',
  POR_METRO_CUBICO: 'R$ por Metro Cúbico'
}

interface Props {
  name: string
  label?: string
  disabled?: boolean
  clearable?: boolean
}

const TipoPedagioLoteSelectInput = ({
  name,
  label,
  disabled,
  clearable
}: Props) => {
  const [field] = useField(name)
  const options = withHistoricalOption(
    tiposPedagioLote,
    field.value,
    LABELS_HISTORICOS
  )

  return (
    <SelectInput
      name={name}
      label={label || 'Tipo Pedágio'}
      options={options}
      disabled={disabled}
      clearable={clearable}
    />
  )
}

export default TipoPedagioLoteSelectInput
